var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"water-level-chart"}},[_c('temphum'),_c('div',{staticClass:"water-level-chart-title"},[_vm._v("本周检测情况")]),_c('div',{staticClass:"water-level-chart-details"},[_vm._v("共检测"+_vm._s(_vm.total)+"次数")]),_c('div',{staticClass:"chart-container"},[_c('dv-water-level-pond',{attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }